// extracted by mini-css-extract-plugin
export default {"link":"NavigationItem_link__+x4EE","active":"NavigationItem_active__IgIii"};